import { render, staticRenderFns } from "./ConfigurationGroupConfigurations.vue?vue&type=template&id=12430522&scoped=true&"
import script from "./ConfigurationGroupConfigurations.vue?vue&type=script&lang=js&"
export * from "./ConfigurationGroupConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12430522",
  null
  
)

export default component.exports